import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import AstaLoader from '@/components/shared/AstaLoader/AstaLoader'
import { Button } from '@/components/ui/button'
import { useSelectedApp } from '@/contexts/selectedApp'
import { useWorkspaceContext } from '@/contexts/workspace'
import { ADMIN_ROUTES } from '@/routes/routes'

const ConfigPage = () => {
	const { workspaces } = useWorkspaceContext()
	const { selectableVariants } = useSelectedApp()
	const navigate = useNavigate()

	useEffect(() => {
		if (selectableVariants?.length > 0) {
			navigate(`/app/${selectableVariants[0]._id}`)
		}
	}, [navigate, selectableVariants])

	if (!workspaces || workspaces.length === 0) {
		return (
			<div className="flex h-screen flex-col items-center justify-center text-center">
				<div className="w-1/2">
					<h1 className="text-4xl font-bold text-foreground">
						There are no workspaces available. Purchase a
						subscription to get one.
					</h1>
				</div>
			</div>
		)
	}

	if (!selectableVariants || selectableVariants.length === 0) {
		return (
			<div className="flex h-screen flex-col items-center justify-center text-center">
				<div className="mb-8 w-1/2">
					<h1 className="text-4xl font-bold text-foreground">
						You have not configured your application yet.
					</h1>
					<p className="mt-4 text-lg text-muted-foreground">
						Please create an application and a variant to start
						using ASTA.
					</p>
				</div>
				<Button
					onClick={() =>
						navigate(ADMIN_ROUTES.workspaces.display().url)
					}
				>
					Configure Application and Variant
				</Button>
			</div>
		)
	}

	return <AstaLoader variant="linear" />
}

export default ConfigPage
